import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import useUserNotifications from "../../hooks/useUserNotifications";
import {
  formatTimeAgo,
  getUserNotificationIcon,
  isNotificationUnread,
  markAllUserNotificationsRead,
  markUserNotificationRead,
} from "../utils/userNotifications";
import NotificationBell from "./NotificationBell";

export default function OwnerNotificationBell() {
  const { currentUser } = useAuth();
  const { notifications, unreadCount } = useUserNotifications();

  return (
    <NotificationBell
      notifications={notifications}
      unreadCount={unreadCount}
      getNotificationIcon={getUserNotificationIcon}
      viewAllPath="/dashboard/my-notifications"
      dropdownId="owner-notifications-dropdown"
      onMarkRead={(id) => markUserNotificationRead(currentUser.uid, id)}
      onMarkAllRead={() => markAllUserNotificationsRead(currentUser.uid)}
      formatTimeAgo={formatTimeAgo}
      isNotificationUnread={isNotificationUnread}
    />
  );
}
